export function findParentElementWithClassname(element: HTMLElement, classname: string): HTMLElement | null {

    let parent: HTMLElement | null = element;

    while (parent !== null) {
        const className = (parent.className || "")
        if (className.includes && className.includes(classname)) return parent;
        parent = parent.parentElement;
    }

    return null;
}